import { GetData } from "../Api";
import React, { useEffect, useState, useContext } from "react";
import "rsuite/dist/rsuite.min.css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import LineOverview from "../Components/LineOverview";
import FilterContext from "../Hooks/Context";
import Filter from "../Components/Filter";
import {factoryStartEndTime} from '../Hooks/Common'

const colors = ["#ffffff", "#ffffff", "#ffffff"];
const delay = 2500;

const Slideshow = () => {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);
  const { t } = useTranslation();

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === colors.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);

  return (
    <div className="slideshow">
      <div
        className="slideshowSlider"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {colors.map((backgroundColor, index) => (
          <div className="slide" key={`slide${index}`} style={{ backgroundColor }}>
            <div className="warning-container">
              <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
              <div className="Heading desktop-only">{ t("LT_warning") }</div>
              <div className="warning-content">
                <div className="Heading mobile-only">{ t("LT_warning") }</div>
                <div className="warning-content-heading">
                { t("LT_inspection_machine") }
                </div>
                <div>{ t("LT_same_defect_has_occurred_5_times_in_an_hour") }.</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="slideshowDots">
        {colors.map((_, idx) => (
          <div
            key={`slidea${idx}`}
            className={`slideshowDot${index === idx ? " active" : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

const LineView = () => {
  const [factoryDataVisiblity, SetFactoryDataVisiblity] = useState(true);
  const [lineData, SetLineData] = useState();
  const { t } = useTranslation();
  const [menuStatus, SetMenuStatus] = useState(false);
  const [liveStatus, SetLiveStatus] = useState(true);

  const filterQueries = useContext(FilterContext);
  const history = useHistory();

  const GetLineData = (lineId) => {
    SetFactoryDataVisiblity(false);
    if (
      filterQueries &&
      filterQueries.filterRequestQuery !== null &&
      filterQueries.filterRequestQuery !== undefined
    ) {
      GetData(
        `line/?lineId=${lineId}&startTs=${filterQueries.filterRequestQuery.startTs}&endTs=${filterQueries.filterRequestQuery.endTs}&shift=${filterQueries.filterRequestQuery.shift}`
      )
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          SetLineData(data);
        })
        .catch((error) => {
          // localStorage.removeItem("token");
          // localStorage.removeItem("refreshToken");
          // history.push("/");
          
          console.error("error - - - - - - - - -", error);
        });
    }
  };

  const ToggleClass = () => {
    SetMenuStatus(!menuStatus);
  };

    /* Live Module Starts from Here */

    const [pauseLive, SetPauseLive] = useState(false);
    const [timeInterval, setTimeInterval] = useState(0);
    var timeout, timeIntervalCount;
  
    const EnableLiveData = (event) => {
      SetPauseLive(false);
  
      let fset = factoryStartEndTime()
        let startDate = fset.startTs
        let endDate = fset.endTs
    
      let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
      filterRequestQuery.isLive = true;
      filterRequestQuery.startTs = startDate;
      filterRequestQuery.endTs = endDate;
      filterQueries.GenerateFilters(filterRequestQuery);
    }
  
    useEffect(() => {
      if(!pauseLive) {
        timeout = setTimeout(() => {
          timeIntervalCount = setTimeInterval(timeInterval + 1);
          }, 60000);
      }
    });
  
    useEffect(() => {
      GetLineData(1);
    },[ filterQueries ]);
  
    useEffect(() => {
      if(filterQueries.filterRequestQuery.isLive) {
        SetPauseLive(false);
      } else {
        SetPauseLive(true);
      }
    },[ filterQueries.filterRequestQuery ]);
  
    useEffect(() => {
      let myDate = new Date( filterQueries.filterRequestQuery.startTs *1000);
      let gmtString = myDate.toGMTString();
      if(filterQueries.filterRequestQuery.isLive) {
        let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
        filterRequestQuery.isLive = true;
        filterQueries.GenerateFilters(filterRequestQuery);
      } else {
        let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
        filterRequestQuery.isLive = false;
        filterQueries.GenerateFilters(filterRequestQuery);
        clearTimeout(timeout);
        clearInterval(timeIntervalCount);
      }
      
    }, [timeInterval]);
  
    /* Live Module Ends from Here */

  useEffect(() => {
    let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
    filterRequestQuery.selectedMenu = "#lineOverview";
    filterQueries.GenerateFilters(filterRequestQuery);
  }, []);

  return (
    <>
      <h4>{ t("LT_shopfloor_overview_line") }</h4>
      { !pauseLive && (
        <span className="liveStatus">
          { t("LT_live") }{" "}
          <span
            className={`showLive ${liveStatus ? "live-icon" : "relay"}`}
          ></span>
        </span>
      )}
      { pauseLive && <div className='live-btn' onClick={ (event) => { EnableLiveData(event) } }>{t("LT_enable_live_data")}</div>}
      <Filter showDatePicker={false} />

      {lineData && <LineOverview data={lineData} />}
      {/* <Slideshow /> */}
    </>
  );
};

export default LineView;
